import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_ITEMMASTER_INIT_ACTION,
  FETCH_ITEMMASTER_SUCCESS_ACTION,
  FETCH_ITEMMASTER_FAIL_ACTION,
  FETCH_ITEMMASTER_BRAND_INIT_ACTION,
  FETCH_ITEMMASTER_BRAND_SUCCESS_ACTION,
  FETCH_ITEMMASTER_BRAND_FAIL_ACTION,
  FETCH_ITEMMASTER_UNIT_INIT_ACTION,
  FETCH_ITEMMASTER_UNIT_SUCCESS_ACTION,
  FETCH_ITEMMASTER_UNIT_FAIL_ACTION,
  FETCH_ITEMMASTER_MEDICALTYPE_INIT_ACTION,
  FETCH_ITEMMASTER_MEDICALTYPE_SUCCESS_ACTION,
  FETCH_ITEMMASTER_MEDICALTYPE_FAIL_ACTION,
  ADD_ITEMMASTER_INIT_ACTION,
  ADD_ITEMMASTER_SUCCESS_ACTION,
  ADD_ITEMMASTER_FAIL_ACTION,
  DELETE_ITEMMASTER_INIT_ACTION,
  DELETE_ITEMMASTER_SUCCESS_ACTION,
  DELETE_ITEMMASTER_FAIL_ACTION,
  EDIT_ITEMMASTER_INIT_ACTION,
  EDIT_ITEMMASTER_SUCCESS_ACTION,
  EDIT_ITEMMASTER_FAIL_ACTION,
  FETCH_ITEMMASTERSEARCH_INIT_ACTION,
  FETCH_ITEMMASTERSEARCH_SUCCESS_ACTION,
  FETCH_ITEMMASTERSEARCH_FAIL_ACTION,
  FETCH_ITEMMASTERINACTIVE_INIT_ACTION,
  FETCH_ITEMMASTERINACTIVE_SUCCESS_ACTION,
  FETCH_ITEMMASTERINACTIVE_FAIL_ACTION,
  FILTER_BY_ITEMMASTER_STATUS_INIT_ACTION,
  FILTER_BY_ITEMMASTER_STATUS_SUCCESS_ACTION,
  FILTER_BY_ITEMMASTER_STATUS_FAIL_ACTION,
  FETCH_ALLBRANDS_INIT,
  FETCH_ALLBRANDS_SUCCESS,
  FETCH_ALLBRANDS_FAIL,
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchItemMaster(value) {
  let pageno = !value.value
    ? 1
    : value.value.pageno === undefined
    ? 1
    : value.value.pageno;
  let filter = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;
  let search = !value.value
    ? ""
    : value.value.search === ""
    ? ""
    : value.value.search;
  let brand = !value.value
    ? ""
    : value.value.brandId === ""
    ? ""
    : value.value.brandId;

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/itemMaster?limit=10&page=${pageno}&status=${filter}&search=${search}&brand=${brand}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log(res);
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_ITEMMASTER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_ITEMMASTER_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchBrand(value) {
  try {
    const params = value && value.value ? value.value : {};
    const page =
      params.page === undefined || params.page === null ? 1 : params.page;
    const limit =
      params.limit === undefined || params.limit === null ? 20 : params.limit;
    const search = params.search
      ? `&search=${encodeURIComponent(params.search)}`
      : "";
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/brand?limit=${limit}&page=${page}${search}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_ITEMMASTER_BRAND_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_ITEMMASTER_BRAND_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchUnit() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/unit`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_ITEMMASTER_UNIT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_ITEMMASTER_UNIT_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchMedicalType() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/itemCategory`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_ITEMMASTER_MEDICALTYPE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_ITEMMASTER_MEDICALTYPE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* AddItemMaster(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      brand: value.value.BrandId,
      drugCode: value.value.drugCode,
      drugName: value.value.drugName,
      descp: value.value.descp,
      unitMeasure: value.value.UnitId,
      unitPrice: value.value.unitPrice,
      taxPernct: value.value.taxPernct,
      taxAmnt: value.value.taxAmnt,
      unitCost: value.value.unitCost,
      medicalType: value.value.ItemCatagoryId,
      remarks: value.value.remarks,
      batchNo: value.value.batchNo,
      mfgDate: value.value.mfgDate,
      expiryDate: value.value.expiryDate,
      hsnCode: value.value.hsnCode,
      mrp: value.value.mrp,
    };
    const res = yield fetch(`${appConfig.ip}/itemMaster`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      console.log("--------------------", resJSON);
      yield put({ type: FETCH_ITEMMASTER_INIT_ACTION });
      yield put({
        type: ADD_ITEMMASTER_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Item Master added successfully", {
        autoClose: 3000,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_ITEMMASTER_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* DeleteItemMaster(value) {
  let id = value.value;
  // let data = {
  //   isActive: false
  // };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/itemMaster/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_ITEMMASTER_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000,
      });
      const resJSON = yield res.json();

      yield put({
        type: DELETE_ITEMMASTER_SUCCESS_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_ITEMMASTER_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* EditItemmaster(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      //  brand: value.value.BrandId,
      drugCode: value.value.drugCode,
      drugName: value.value.drugName,
      descp: value.value.descp,
      // unitMeasure: value.value.UnitId,
      unitPrice: value.value.unitPrice,
      taxPernct: value.value.taxPernct,
      taxAmnt: value.value.taxAmnt,
      unitCost: value.value.unitCost,
      // medicalType: value.value.ItemCatagoryId,
      remarks: value.value.remarks,
      batchNo: value.value.batchNo,
      mfgDate: value.value.mfgDate,
      expiryDate: value.value.expiryDate,
      hsnCode: value.value.hsnCode,
      mrp: value.value.mrp,
    };

    const res = yield fetch(`${appConfig.ip}/itemMaster/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_ITEMMASTER_INIT_ACTION });
      yield put({
        type: EDIT_ITEMMASTER_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Item Master updated successfully", {
        autoClose: 3000,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_ITEMMASTER_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchItemMasterInActive(data) {
  let datas =
    data.value.item.status === "active"
      ? { status: "suspended" }
      : { status: "active" };

  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/itemMaster/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_ITEMMASTERINACTIVE_SUCCESS_ACTION,
        payload: resJSON,
      });

      yield toast.success("Status changed successfully", {
        autoClose: 3000,
      });

      const refreshParams =
        data &&
        data.value &&
        data.value.refreshParams
          ? data.value.refreshParams
          : undefined;
      yield put({
        type: FETCH_ITEMMASTER_INIT_ACTION,
        value: refreshParams,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_ITEMMASTERINACTIVE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchAllbrands() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/brand/all`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_ALLBRANDS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_ALLBRANDS_FAIL,
        error: err,
      });
    }
  }
}

export function* ItemMasterActionWatcher() {
  yield takeEvery(FETCH_ITEMMASTER_INIT_ACTION, fetchItemMaster);
  yield takeEvery(FETCH_ITEMMASTER_BRAND_INIT_ACTION, fetchBrand);
  yield takeEvery(FETCH_ITEMMASTER_UNIT_INIT_ACTION, fetchUnit);
  yield takeEvery(FETCH_ITEMMASTER_MEDICALTYPE_INIT_ACTION, fetchMedicalType);
  yield takeEvery(ADD_ITEMMASTER_INIT_ACTION, AddItemMaster);
  yield takeEvery(DELETE_ITEMMASTER_INIT_ACTION, DeleteItemMaster);
  yield takeEvery(EDIT_ITEMMASTER_INIT_ACTION, EditItemmaster);
  yield takeEvery(
    FETCH_ITEMMASTERINACTIVE_INIT_ACTION,
    fetchItemMasterInActive
  );
  yield takeEvery(FETCH_ALLBRANDS_INIT, fetchAllbrands);
}
